module.exports = __webpack_public_path__ + "static/media/rom20.44faa5b3.jpg";